module.exports = __webpack_public_path__ + "img/file-earmark-excel-fill.8bd498cc.svg";